<template>
  <div style="border: 0px solid black; ; display:block">
    <div class="welcome" style="border: 0px solid red;">
      <div class="box-body">
        <div class="box box-success">
          <div class="box-body">
            <!--  -->
            <div class="col-md-12">
              <div class="panel with-nav-tabs panel-info">
                <div class="panel-heading">
                  <ul class="nav nav-tabs">
                    <li class="active" @click="onSelectTab(1)">
                      <a href="#tab1warning" data-toggle="tab">{{
                        $t("customization_table.smtp_title")
                      }}</a>
                    </li>
                    <!-- <li @click="onSelectTab(2)">
                      <a href="#tab3warning" data-toggle="tab">{{
                        $t("sidebar.projectsettings.project_smtp")
                      }}</a>
                    </li> -->
                  </ul>
                </div>
                <div class="panel-body">
                  <div class="tab-content">
                    <div class="tab-content">
                      <div class="row" >
                        <div class="col-sm-12 col-md-12" style="display: flex;">
                          <span
                            v-for="(item, index) in tabList"
                            :key="item + index"
                            :class="`${index !== tabList.length - 1 ? 'tabitem-type-class border-right' : 'tabitem-type-class'}`"
                            @click="onChangeSmtpTab(item.value)"
                          >
                            <span
                              :class="item.value === tabSelect ? 'tabitem-type-select' : ''"
                              style="white-space: nowrap;"
                            >
                              {{ $t(item.text) }}
                            </span>
                          </span>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <div v-if="tabSelect!=SMTPServiceEnum.BQL_SMTP">
                            <input
                              type="checkbox"
                              id="checkUsePrivateSmtp"
                              name="checkUsePrivateSmtp"
                              class="custom-control-input"
                              v-model="smtpProject.isUsePrivateSmtpCSHK"
                              :value="false"
                              @change="onShowConfirm()"
                            />
                            <label class="custom-control-label" for="checkUsePrivateSmtp">
                              {{ $t("customSMTPConfig.useCustomConfig")}}
                            </label>
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <button
                            v-if="isSuperAdmin()"
                            type="button"
                            class="btn btn-labeled btn-primary pull-right"
                            style="margin-right: 5px;"
                            @click="onChangeSMTPProject"
                          >
                            <span class="btn-label">
                              <i class="glyphicon glyphicon-th"></i>
                            </span>
                            {{ $t("customization_table.selectSMTPProject") }}
                          </button>
                        </div>
                      </div>
                      <div v-if="tabSelect==SMTPServiceEnum.BQL_SMTP || smtpProject.isUsePrivateSmtpCSHK">
                        <ConfigSMTPProject :smtpProjectId="selectedSmtpProjectId" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-default" id="modal-select-project-smtp">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{$t('customization_table.selectSMTPProject')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label
                for="title"
              >{{$t('customization_table.smtp_server.smtp_project')}}</label>
              <select
                name=""
                id=""
                class="form-control"
                v-model="selectedSmtpProjectId"
              >
                <option
                  v-for="(smtpProject, index) in smtpProjectList"
                  :key="smtpProject + index"
                  :value="smtpProject.id"
                  >{{ smtpProject.projectName }}</option
                >
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              >{{$t('confirm_email.btnClose')}}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onSaveSMPTProject"
              >{{$t('confirm_email.btnConfirm')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onChangeUseCustom"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading :active.sync="is_loading" :can-cancel="false" color="#1E90FF">
    </loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import LTEModal from "@/components/LTEModal.vue";
import Loading from "vue-loading-overlay";
import Enum from "../../../enum/enum";
import utils from '@/lib/utils'
import ConfigSMTPProject from "./ConfigSMTPProject.vue"

export default {
  name: "CustomizationTable_SMTP",
  data() {
    return {
      SMTPServiceEnum: Enum.SMTPServiceEnum,
      tabSelect: Enum.SMTPServiceEnum.BQL_SMTP,
      tabList: [
        {
          value: Enum.SMTPServiceEnum.BQL_SMTP,
          text: "customization_table.customSMTPService.management_SMTP"
        },
        {
          value: Enum.SMTPServiceEnum.CSKH_SMTP,
          text: "customization_table.customSMTPService.CSKH_SMTP"
        }
      ],
      selectedSmtpProjectId: null,
      smtpProject: {
        projectIdBQL: null,
        projectIdCSKH: null,
        isUsePrivateSmtpCSHK: false,
      },
      isModalVisible: false,
      objModal: [
        {
          title: "customSMTPConfig.title",
          body: "customSMTPConfig.notificationChangeUseSMTPConfig",
          buttonNo: "customSMTPConfig.cancel",
          buttonYes: "customSMTPConfig.confirm",
          styleType: "default"
        }
      ],
      smtpProjectList: [],
      is_loading: false
    };
  },
  watch: {
    GET_SETTING_PROJECT_SMTP_DATA: function() {
      this.smtpProject.projectIdBQL = this.GET_SETTING_PROJECT_SMTP_DATA.smtp_bql_project_id;
      this.smtpProject.projectIdCSKH = this.GET_SETTING_PROJECT_SMTP_DATA.smtp_cskh_project_id;
      this.smtpProject.isUsePrivateSmtpCSHK = this.GET_SETTING_PROJECT_SMTP_DATA.is_smtp_cskh_private;
      this.selectedSmtpProjectId = this.smtpProject.projectIdBQL
    },
    GET_SMTP_PROJECT_LIST_DATA: function() {
      this.smtpProjectList = [];
      this.GET_SMTP_PROJECT_LIST_DATA.forEach(data => {
        let item = {
          id: data.id,
          projectName: data.name
        };
        this.smtpProjectList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_SMTP_PROJECT_LIST_DATA",
      "GET_SETTING_PROJECT_SMTP_DATA",
    ])
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "USING_PRIVATE_SMTP_CONFIG",
      "GET_SMTP_PROJECT_LIST",
      "GET_SETTING_PROJECT_SMTP",
      "SET_PROJECT_SMTP_SETTING"
    ]),
    isSuperAdmin: function() {
        return utils.isSuperAdmin(this.GET_ACCOUNT_DATA);
    },
    onChangeSmtpTab: function(value) {
      this.tabSelect = value;
      if (value === this.SMTPServiceEnum.BQL_SMTP) {
        this.selectedSmtpProjectId = this.smtpProject.projectIdBQL
      }
      else if (value === this.SMTPServiceEnum.CSKH_SMTP) {
        this.selectedSmtpProjectId = this.smtpProject.isUsePrivateSmtpCSHK ? this.smtpProject.projectIdCSKH : null
      }
    },
    onShowModalSelectProject: function () {
      $("#modal-select-project-smtp").modal("show");
    },
    onHideModalSelectProject: function () {
      $("#modal-select-project-smtp").modal("hide");
    },
    onChangeSMTPProject: function() {
      this.onShowModalSelectProject()
    },
    onShowConfirm: function() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.smtpProject.isUsePrivateSmtpCSHK = !this.smtpProject.isUsePrivateSmtpCSHK;
    },
    onChangeUseCustom: function() {
      let data = {
        usedPrivateSmtp: this.smtpProject.isUsePrivateSmtpCSHK
      };
      if (this.tabSelect === this.SMTPServiceEnum.CSKH_SMTP) {
        this.selectedSmtpProjectId = this.smtpProject.isUsePrivateSmtpCSHK ? this.smtpProject.projectIdCSKH : null
      }
      this.USING_PRIVATE_SMTP_CONFIG(data)
        .then(
          function(res) {
            this.isModalVisible = false;
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    onSaveSMPTProject: function() {
      if (utils.isEmptyString(this.selectedSmtpProjectId)) {
        this.ON_SHOW_TOAST({
          message: this.$t('customization_table.smtp_server.smtp_project'),
          styleType: "danger"
        });
      } else {
        let data = {
          smtpProjectId: this.selectedSmtpProjectId,
          serviceKey: this.tabSelect
        }
        this.SET_PROJECT_SMTP_SETTING(data)
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            this.onHideModalSelectProject()
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
      }
    },
    onSelectTab: function(value) {
      switch (value) {
        case 1:
          break;

        default:
          break;
      }
    }
  },
  mounted() {
    this.GET_SETTING_PROJECT_SMTP();
    this.GET_SMTP_PROJECT_LIST();
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "lte-modal": LTEModal,
    loading: Loading,
    ConfigSMTPProject
  }
};
</script>

<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL WARNING ***/
.with-nav-tabs.panel-warning .nav-tabs > li > a,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning .nav-tabs > .open > a,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
  background-color: #faebcc;
  border-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.active > a,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:focus {
  color: #8a6d3b;
  background-color: #fff;
  border-color: #faebcc;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #faebcc;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  color: #fff;
  background-color: #8a6d3b;
}
/*  */
.lnu_container {
  display: block;
  margin: 10px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, 0.8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.got_lowercase,
.got_uppercase,
.got_number {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
.tabitem-type-class {
  padding: 5px 15px;
  cursor: pointer;
}
.border-right {
  border-right: 1px solid #000000 !important;
}
.tabitem-type-select {
  font-weight: bold;
  color: #006ad4;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/CustomizationTable_SMTP.vue